export default __webpack_public_path__ + "media/images/gift_fund/revolut-7c4389b0b5a4f4d12ab505c07a3a4de1.svg";